import { $authHost, $host } from ".";
import  { jwtDecode } from "jwt-decode";
import { getFingerprint } from "../utils/fingerprint.js";

export const signin = async (login, password) => {
    try {
        // Получаем fingerprint браузера
        const fingerprint = await getFingerprint();
        
        const response = await $host.post('/api/auth/login', { 
            login, 
            password, 
            fingerprint 
        });
        
        const data = response.data;
        localStorage.setItem('token', data.accessToken);
        
        return jwtDecode(data.accessToken);
    } catch (error) {
        console.error('Signin error:', error);
        throw error;
    }
}

export const check = async () => {
    try {
        const { data } = await $authHost.get('/api/auth/check');
        localStorage.setItem('token', data.accessToken);
        
        return jwtDecode(data.accessToken);
    } catch (error) {
        console.error('Check error:', error);
        throw error;
    }
}

export const getUsers = async () => {
    try {
        const data = await $authHost.get('/api/user/all')
        return data
    } catch(e) {
        console.log(e)
    }
    
}
export const getRoles = async () => {
    try{ 
        const data = await $authHost.get('/api/role/all')
        return data
    } catch(e) {
        console.log(e)
    }
}
export const addUser = async (user) => {
    try{ 
        const data = await $authHost.post('/api/user', user)
        return data
    } catch(e) {
        console.log(e)
    }
}
export const addRole = async (user) => {
    try{ 
        const data = await $authHost.post('/api/role/create', user)
        return data
    } catch(e) {
        console.log(e)
    }
}
export const editUser = async (user) => {
    try {
        const data = await $authHost.put(`/api/user/${user.id}`, user)
        return data
    } catch(e) {
        console.log(e)
    }
}

export const deleteUser = async (user) => {
    try {
        const data = await $authHost.delete(`/api/user/${user.id}`)
        return data
    } catch(e) {
        console.log(e)
    }
}

// API функции для управления fingerprint
export const enableFingerprint = async (userId) => {
    try {
        const data = await $authHost.post(`/api/user/${userId}/fingerprint/enable`)
        return data
    } catch(e) {
        console.log(e)
        throw e
    }
}

export const disableFingerprint = async (userId) => {
    try {
        const data = await $authHost.post(`/api/user/${userId}/fingerprint/disable`)
        return data
    } catch(e) {
        console.log(e)
        throw e
    }
}

export const clearFingerprint = async (userId) => {
    try {
        const data = await $authHost.post(`/api/user/${userId}/fingerprint/clear`)
        return data
    } catch(e) {
        console.log(e)
        throw e
    }
}

export const getFingerprintStatus = async (userId) => {
    try {
        const data = await $authHost.get(`/api/user/${userId}/fingerprint/status`)
        return data
    } catch(e) {
        console.log(e)
        throw e
    }
}

